import React, { useState } from "react";
import MuiButton from "./MuiButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "jalali-moment";

// import JS files
import MuiSelect from "./MuiSelect";
import MuiTextField from "./MuiTextField";
import MuiDatePicker from "./MuiDatePicker";

const PanelFilter = (props) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <div className="filter-container">
        <p className="header">{props.header}</p>
        <div className={`grid md:grid-cols-6 gap-y-6 gap-x-4 my-6`}>
          {props.list.map((item, index) => {
            if (item.type == "textField") {
              return [
                <>
                  <MuiTextField
                    isLTR={item.isLTR}
                    id={item.label_en}
                    label={item.label_fa}
                    variant="outlined"
                    size="small"
                    onChange={(e) =>
                      props.update_filter(item.label_en, e.target.value)
                    }
                    value={item.state !== null ? item.state : ""}
                  />
                </>,
              ];
            } else if (item.type == "datePicker") {
              return [
                <>
                  <MuiDatePicker
                    onChange={(date) =>
                      props.update_filter(
                        item.label_en,
                        moment(date).format("YYYY-MM-DD")
                      )
                    }
                    value={item.state !== null ? item.state : null}
                    name={item.label_en}
                    label={item.label_fa}
                  />
                </>,
              ];
            } else {
              return [
                <>
                  <MuiSelect
                    size="small"
                    inputLabel={item.label_fa}
                    labelId={`${item.label_en}-label`}
                    id={`${item.label_en}-select`}
                    label={item.label_en}
                    menuItems={item.menuItems}
                    fromApi={item.fromApi}
                    onChange={(e) =>
                      props.update_filter(item.label_en, e.target.value)
                    }
                    value={item.state !== null ? item.state : "all"}
                    defaultValue={item.state !== null ? item.state : "all"}
                    haveAllOption={true}
                  />
                </>,
              ];
            }
          })}
          <div className="flex">
            <MuiButton
              onClick={props.filter}
              variant="contained"
              icon={<SearchIcon />}
              color="primary"
              text="فیلتر"
            />
            <MuiButton
              onClick={props.reset_filter}
              variant="outlined"
              icon={<ClearIcon />}
              color="primary"
              text="حذف فیلتر"
              margin="mr-2"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PanelFilter;
